import DataLoader from 'dataloader'
import { createContext, FC, PropsWithChildren, useContext } from 'react'
import { useApi } from 'service/useApi'

import { createCurrencyConversionRatesDataLoader } from './createCurrencyConversionRatesDataLoader'
import { CurrencyConversionRatesQuery } from './domain/ConversionRates'

export const CurrencyConversionRatesDataLoaderContext = createContext<DataLoader<
  CurrencyConversionRatesQuery,
  number,
  CurrencyConversionRatesQuery
> | null>(null)

export const CurrencyConversionRatesDataLoaderProvider: FC<PropsWithChildren> = ({ children }) => {
  const API = useApi()

  const dataloader = createCurrencyConversionRatesDataLoader(API.fx.getConversionRates)

  return (
    <CurrencyConversionRatesDataLoaderContext.Provider value={dataloader}>
      {children}
    </CurrencyConversionRatesDataLoaderContext.Provider>
  )
}

export const useCurrencyConversionRatesDataLoader = () => {
  const context = useContext(CurrencyConversionRatesDataLoaderContext)

  if (!context) {
    throw new Error('Must use useCurrencyConversionRatesDataLoader in CurrencyConversionRatesDataLoaderContext')
  }

  return context
}
